import 'react-toastify/dist/ReactToastify.css';
import 'animate.css';
import Routes from './routes/Routes';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'draft-js/dist/Draft.css';
import './redux/api/API'
import './style/style.css'
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <>
      <Routes />
      <ToastContainer />
    </>
  );
}

export default App;
